// plugin/loadStore.js
// - List of shared stores
import Navbar from '@store/navbar'
import Authentication from '@store/authentication'
import Global from '@store/global'

export default ({ store }) => {
  store.registerModule('navbar', Navbar)
  store.registerModule('authentication', Authentication)
  store.registerModule('global', Global)
}
